import { forwardRef } from 'react';
import cn from 'classnames';
import get from 'lodash/get';
import { Button, BUTTON_THEMES } from 'ht-styleguide';
/* Components */
import SubNav from '@components/SubNav';
import ServicePrice from '@scenes/ServiceSkuPage/Parts/ServicePrice';
import SkuImage from '@components/Sku/SkuImageThumbnail';
import { SERVICE_HEADER_TRIGGER_ID } from './constants';
/* Styles */
import styles from './serviceheader.module.scss';

/* Types */
import { ZipSplitTest } from '@components/Sku/ZipCodeEntry/ZipCodeEntry';
import { RefReference } from 'types/base.types';

type ServiceHeaderProps = {
  sku?: Partial<{
    name: string;
    ctaText: string;
    showZipCodeTest: ZipSplitTest;
  }>;
  className?: string;
  onBook: BaseAnyFunction;
  onInfo: BaseAnyFunction;
  showFixedPrice?: boolean;
  linethroughPrice?: boolean;
  visible: boolean;
  trigger?: string;
};

const ServiceHeader = (
  { sku, className, onBook, onInfo, showFixedPrice, linethroughPrice, trigger = `#${SERVICE_HEADER_TRIGGER_ID}` }: ServiceHeaderProps,
  ref: RefReference<HTMLDivElement>,
) => {
  if (!sku) return null;

  const priceStyles = linethroughPrice ? styles.linethroughPrice : styles.price;
  const serviceImage = get(sku, 'image', undefined);

  return (
    <SubNav
      data-testid="sku-service-secondary-header"
      ref={ref}
      innerClasses={cn('flex alignItemsCenter justifyContentSpaceBetween', styles.header, className)}
      startElementSelector={trigger}
    >
      <SkuImage image={serviceImage!} />
      <div className={priceStyles}>
        <h5>{sku.name}</h5>
        {!sku.showZipCodeTest && <ServicePrice sku={sku} sm onInfo={onInfo} showFixedPrice={showFixedPrice} linethroughPrice={linethroughPrice} />}
      </div>

      <Button theme={BUTTON_THEMES.PRIMARY} huge onClick={onBook} className={styles.button}>
        {sku.ctaText}
      </Button>
    </SubNav>
  );
};

export default forwardRef(ServiceHeader);
